import AboutRoutes from "./AboutRoutes";
import EducationRoutes from "./EducationRoutes";
import CoursesRoutes from "./CoursesRoutes";
import PersonRoutes from "./PersonRoutes";
import DepartmentRoutes from "./DepartmentRoutes";
import LiveRoutes from "./LiveRoutes";
import ResearchRoutes from "./ResearchRoutes";
import CooperationRoutes from "./CooperationRoutes";
import InternationalRoutes from "./InternationalRoutes";
import InternalRoutes from "./InternalRoutes";
import GlobalRoutes from "./GlobalRoutes";
import DevRoutes from "./DevRoutes";

const Routes = {
  routes: [
    ...AboutRoutes.routes,
    ...EducationRoutes.routes,
    ...CoursesRoutes.routes,
    ...PersonRoutes.routes,
    ...DepartmentRoutes.routes,
    ...LiveRoutes.routes,
    ...ResearchRoutes.routes,
    ...CooperationRoutes.routes,
    ...InternationalRoutes.routes,
    ...InternalRoutes.routes,
    ...GlobalRoutes.routes
  ]
};

// add dev routes such as markdown documentation for development environment
if (process.env.NODE_ENV === "development")
  Routes.routes = [...Routes.routes, ...DevRoutes.routes];

export default Routes;
